import * as aiacemedAction from "./aiacemedAction";

export const aiacemedFeatureKey = "aiacemedInfo";

const initialState = {
  loading: false,
  errorMsg: "",
  prompts: [],
  promptDetails: {},
  isPromptUpdated: false,
};

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case aiacemedAction.GET_PROMPTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case aiacemedAction.GET_PROMPTS_SUCCESS:
      return {
        ...state,
        loading: false,
        prompts: payload.data || [],
      };
    case aiacemedAction.GET_PROMPTS_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case aiacemedAction.GET_PROMPT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case aiacemedAction.GET_PROMPT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        promptDetails: payload.data || {},
      };
    case aiacemedAction.GET_PROMPT_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case aiacemedAction.CREATE_PROMPT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case aiacemedAction.CREATE_PROMPT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case aiacemedAction.CREATE_PROMPT_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case aiacemedAction.UPDATE_PROMPT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case aiacemedAction.UPDATE_PROMPT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case aiacemedAction.UPDATE_PROMPT_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case aiacemedAction.DELETE_PROMPT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case aiacemedAction.DELETE_PROMPT_SUCCESS:
      return {
        ...state,
        loading: false,
        isPromptUpdated: true,
      };
    case aiacemedAction.DELETE_PROMPT_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case "IS_PROMPT_UPDATED":
      return {
        ...state,
        isPromptUpdated: false,
      };
    default:
      return state;
  }
};
